import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import NoticeboardAPICall from 'NoticeboardAPICall';
import ButtonLoader from 'NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader';
import config from 'config';
import Pagination from 'react-js-pagination';
import DeleteModal from 'NOTICEBOARD/CommonResources/DeleteModal/DeleteModal';
import SuccessModal from 'NOTICEBOARD/CommonResources/SuccessModal/SuccessModal';
import { toast } from 'react-toastify';

import './UserList.css';
let apiPath = '/api/notice/category.php';


function UserList() {

    // STATE FOR USER MANAGEMENT LIST 
    const [userFetching, setUserFetching] = useState(false);
    const [userList, setUserList] = useState({});
    const [totalCount, setTotalCount] = useState(0);
    const [filterUser, setFilterUser] = useState('');
    const [selectedUserIds, setUserIds] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);

    // STATE FOR USER LIST PAGINATION 
    const [pagination, setPagination] = useState({
        offset: 0,
        activePage: 1
    });

    // STATE TO SET LIMIT FOR USER LIST  
    const [limit, setLimit] = useState(10);

    // METHOD FOR SUCCESS MODAL FOR USER MANAGEMENT
    const [successModalDetails, setSuccessModalDetails] = useState({
        successModal: false,
        successModalType: '',
        successMessage: ''
    });

    // METHOD FOR DELETE MODAL FOR USER MANAGEMENT
    const [deleteModalDetails, setDeleteModalDetails] = useState({
        deleteModal: false,
        deleteModalText: '',
        deleteErrorVisibility: false
    })

    // HOOKS FOR USER LIST API CALL
    useEffect(() => {
        getUserListAPICall();
    }, [])

    // HOOKS FOR USER LIST PAGINATION
    useEffect(() => {
        getUserListAPICall();
    }, [pagination])

    // METHOD TO GET USER LIST API CALL
    const getUserListAPICall = async () => {
        setUserFetching(true);

        let formData = {
            "iid": config.institute_id,
            "offset": pagination.offset,
            "limit": limit,
            "filter_name": filterUser
        }

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'getUserManagementlist',
            formData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getUserListAPICall();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(userId => {
                        apiResult[userId]['userId'] = userId;
                    });
                }

                setUserList(apiResult);
                setTotalCount(jsonResponse.APIResult.totalCount);
                setUserFetching(false);
            }
        }
    }

    // METHOD TO DELETE USER API CALL
    const getDeleteUserAPICall = async () => {
        let formData = {
            "institute_id": config.institute_id,
            "user_id_array": selectedUserIds,
            "added_by" : config.faculty_id,


        }

        let jsonResponse = await NoticeboardAPICall.makeApiCall(
            'removeUserCategoryAccess',
            formData,
            apiPath
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                getDeleteUserAPICall();
            }, 1000);

        } else {
            if (jsonResponse.success) {
                if (jsonResponse.APIResult.status == "success") {
                    setDeleteModalDetails({
                        DeleteModal: false,
                    });
                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: "success",
                        successMessage: jsonResponse.APIResult.message
                    });

                    let selectedUserId = selectedUserIds;
                    selectedUserId = [];
                    setUserIds([...selectedUserId]);
                    getUserListAPICall();

                } else {
                    setDeleteModalDetails({
                        DeleteModal: false,
                    });
                    setSuccessModalDetails({
                        successModal: true,
                        successModalType: "warning",
                        successMessage: jsonResponse.APIResult.message
                    });
                }
            } else {
                setDeleteModalDetails({
                    DeleteModal: false,
                });
                setSuccessModalDetails({
                    successModal: true,
                    successModalType: "error",
                    successMessage: 'Something went wrong while deleting category. Please try again later.'
                });
            }
        }
    }


    // METHOD TO DELETE USER MODAL
    const getDeleteUserDetails = () => {
        setDeleteModalDetails({
            deleteModal: true,
        })
    }

    // METHOD FOR CLOSE DELETE MODAL
    const closeDeleteModal = () => {
        setDeleteModalDetails({
            DeleteModal: false,
            deleteModalText: '',
            deleteErrorVisibility: false,
        })
    }

    // METHOD FOR USER PAGINATION COUNT
    const updatePaginationCount = (pageNumber) => {
        setPagination({
            offset: ((pageNumber - 1) * limit),
            activePage: pageNumber
        })
        setUserIds([]);
    }

    // METHOD FOR SET SHOW RESULT
    const setShowResult = (e) => {
        setPagination({
            activePage: 1,
            offset: 0
        });
        setLimit(e.target.value);
    }

    // METHOD TO APPLY FILTER
    const applyFilterUser = () => {
        setPagination({
            offset: 0,
            limit: 10,
            activePage: 1
        });
        setFilterApplied(true);
    }

    // METHOD FOR CLOSE FILTER USER
    const closeFilterUser = () => {
        setFilterApplied(false);
        setFilterUser('');
        getUserListAPICall();
        setPagination({
            offset: 0,
            limit: 10,
            activePage: 1
        });
    }

    // METHOD TO SEARCH BY USER NAME
    const searchUserByName = (e) => {
        if (e.charCode == 13) {
            getUserListAPICall(e.target.value)
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    const closeSuccessModal = () => {
        setSuccessModalDetails({
            successModal: false,
            successModalType: "",
            successMessage: ""
        })
    }

    // METHOD TO SELECT ALL USERS
    const selectAllUsers = (e) => {
        let userIdSet = new Set();
        if (e.target.checked) {
            Object.keys(userList).map(userId => {
                userIdSet.add(userId);
            });
        } else {
            Object.keys(userList).map(userId => {
                userIdSet.delete(userId);
            });
        }

        setUserIds(Array.from(userIdSet));
    }

    // METHOD TO SELECT SINGLE USER
    const selectSingleUser = (userObject) => {
        let selectedUserId = selectedUserIds;
        let userId = userObject.userId;

        if (Object.keys(userObject.categoryObject).length > 0) {
            if (selectedUserId.includes(userId)) {
                selectedUserId = selectedUserId.filter(id => id != userId);
            } else {
                selectedUserId.push(userId);
            }
            setUserIds([...selectedUserId]);
        }
        else {
            setSuccessModalDetails({
                successModal: true,
                successModalType: "warning",
                successMessage: "Faculty is not assigned to any category. Please select another faculty who is assigned to category.",
            })
        }

    }

    return (
        <>
            <div 
                className='d-flex flex-wrap' 
                style={ { 
                    backgroundColor: "#f2f2f2", 
                    marginTop: 10, 
                    padding: '8px 15px',
                    position: 'sticky',
					top: '10%',
					zIndex: 20,
                } }
            >
                <div className='filterUser flex-grow-1'>
                    <div style={ { fontSize: 14 } }>
                        <input
                            type="text"
                            className='form-control addUserInput'
                            placeholder='Enter User Name'
                            value={ filterUser }
                            onChange={ (e) => setFilterUser(e.target.value) }
                            onKeyPress={ (e) => searchUserByName(e) }
                            style={ { fontSize: 14 } }
                        />
                    </div>
                    <div className="filterButtons">
                        <button className="btn primary-button" onClick={ () => applyFilterUser() } >Apply</button>
                        <button className="btn btn-outline-blue" onClick={ () => closeFilterUser() } >Clear</button>
                    </div>
                </div>
                <div className='showUsers'>
                    <div>
                        <label style={ { fontSize: 12, alignItems: 'center', marginRight: 10 } } >Show Results</label>
                    </div>
                    <div >
                        <select
                            className="form-select"
                            aria-label="Default select example"
                            value={ limit }
                            onChange={ (e) => setShowResult(e) }
                            style={ { fontSize: 12, marginRight: 10 } }
                        >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="40">40</option>
                            <option value="100">100</option>
                            <option value="250">250</option>
                        </select>
                    </div>
                    &nbsp;&nbsp;
					<div 
						className='mr-2'
						style={{ fontSize: 'smaller' }}
					>
						Total records: {totalCount}				
					</div>	
                </div>
            </div>
            <div className='table-responsive col-md-12'>
                <table className='table  table-bordered '>
                    <thead
                        style={ { 
							position: 'sticky',
							top: '0',
							backgroundColor: '#fff',
						} }
                    >
                        <tr>
                            <th style={ { padding: 5 } }>
                                <input
                                    type="checkbox"
                                    checked={ Object.keys(userList).length > 0 && Object.keys(userList).length == selectedUserIds.length }
                                    onChange={ (e) => selectAllUsers(e) }
                                />
                            </th>
                            <th style={ { padding: 5, } }>Sr.No.</th>
                            <th style={ { padding: 5, } }>Name</th>
                            <th style={ { padding: 5, } }>Category</th>
                            <th style={ { padding: 5, wordWrap: "break-word" } }>Department to Post Notice</th>
                            {/* <th style={ { padding: 5, wordWrap: "break-word" } }>Department to Approve Notice</th> */}
                            <th style={ { padding: 5, } }>Posted Notices</th>
                        </tr>
                        {
                            selectedUserIds.length > 0 &&
                            <tr className="active-row" style={ { backgroundColor: "#fed7660d" } }>
                                <td colSpan="11" className="componentAction-button">
                                    <div style={ { padding: 5 } }>
                                        <span style={ { border: "1px solid black", borderRadius: "30px", padding: 5, cursor: "pointer" } } onClick={ () => getDeleteUserDetails() } >
                                            Delete
                                        </span>
                                    </div>
                                </td>
                            </tr>
                        }
                    </thead>
                    <tbody >
                        {
                            userFetching ?
                                <tr>
                                    <td colSpan={ 6 } style={ { padding: 5 } }>
                                        <ButtonLoader />
                                    </td>
                                </tr>
                            :
                                Object.keys(userList).length > 0 ?
                                    Object.values(userList).map((users, usersIndex) => {
                                        return (
                                            <>
                                                <tr key={ users.userId }>
                                                    <td style={ { padding: 5 } } rowSpan={ Object.keys(users.categoryObject).length > 0 ? Object.keys(users.categoryObject).length : 1 }>
                                                        <input
                                                            type="checkbox"
                                                            checked={ selectedUserIds.includes(users.userId) }
                                                            onChange={ () => selectSingleUser(users) }
                                                        />
                                                    </td>
                                                    <td style={ { padding: 5 } } rowSpan={ Object.keys(users.categoryObject).length > 0 ? Object.keys(users.categoryObject).length : 1 }>{ pagination.offset + usersIndex + 1 }</td>
                                                    <td className='td' style={ { padding: 5 } } rowSpan={ Object.keys(users.categoryObject).length > 0 ? Object.keys(users.categoryObject).length : 1 }>{ users.facultyName }</td>
                                                    {
                                                        users.categoryObject != undefined && Object.keys(users.categoryObject).length > 0 ?
                                                            Object.values(users.categoryObject).map((names, index) => {

                                                                if (index == 0) {
                                                                    return (
                                                                        <>
                                                                            <td style={{ padding: 5 }} title={names.categoryName}>
                                                                                <p style={{ width: 300, textOverflow: 'ellipsis', overflow: 'hidden' }}>{names.categoryName}</p>
                                                                            </td>
                                                                            <td style={{ padding: 5, wordWrap: "break-word", whiteSpace: "normal" }}>{names.department}</td>
                                                                            {/* <td style={{ padding: 5, wordWrap: "break-word", whiteSpace: "normal" }}>{names.noticeApproverDepartment != undefined ? names.noticeApproverDepartment : ''}</td> */}
                                                                            <td style={{ padding: 5 }}>{names.PostedNotices}</td>
                                                                        </>
                                                                    )
                                                                }

                                                            })
                                                            :
                                                            <>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                                <td></td>
                                                            </>
                                                    }
                                                </tr>
                                                {
                                                    users.categoryObject != undefined && Object.keys(users.categoryObject).length > 1 &&
                                                        Object.values(users.categoryObject).map((names, index) => {
                                                            if (index > 0) {
                                                                return (
                                                                    <tr>
                                                                        <td style={{ padding: 5 }} title={names.categoryName}>
                                                                            <p style={{ width: 300, textOverflow: 'ellipsis', overflow: 'hidden' }}>{names.categoryName}</p>
                                                                        </td>
                                                                        <td style={{ padding: 5, wordWrap: "break-word", whiteSpace: "normal" } }>{names.department}</td>
                                                                        {/* <td style={{ padding: 5, wordWrap: "break-word", whiteSpace: "normal" } }>{names.noticeApproverDepartment != undefined ? names.noticeApproverDepartment : ''}</td> */}
                                                                        <td style={{ padding: 5 }}>{names.PostedNotices}</td>
                                                                    </tr>
                                                                )
                                                            }
                                                        })
                                                }
                                            </>
                                        );
                                    })
                                :
                                    filterApplied ?
                                        <tr>
                                            <td colSpan={ 6 } style={ { padding: 5 } }>
                                                No user details found as per search.
                                            </td>
                                        </tr>
                                    :
                                        <tr>
                                            <td colSpan={ 6 } style={ { padding: 5 } }>
                                                No user added yet.
                                            </td>
                                        </tr>
                        }
                    </tbody>
                </table>
                {/* PAGINATION FOR USER MANAGEMENT LIST */ }
                {
                    Object.keys(userList).length > 0 &&
                        <div className="paginationContainer">
                            <Pagination
                                activePage={ pagination.activePage }
                                itemsCountPerPage={ limit }
                                totalItemsCount={ totalCount }
                                pageRangeDisplayed={ 3 }
                                onChange={ (num) => updatePaginationCount(num) }
                            />
                        </div>
                }
            </div>


            {/* DELETE MODAL FOR USER MANAGEMENT LIST */ }
            {
                deleteModalDetails.deleteModal &&
                    <DeleteModal
                        showModal={ deleteModalDetails.deleteModal }
                        visibility={ closeDeleteModal }
                        deleteKey="User"
                        getMessage={ deleteModalDetails.getMessage }
                        deleteComponent={ getDeleteUserAPICall }

                    />
            }
            {/* SUCCESS MODAL FOR USER MANAGEMENT LIST */ }
            {
                successModalDetails.successModal &&
                    <SuccessModal
                        successModal={ successModalDetails.successModal }
                        successModalType={ successModalDetails.successModalType }
                        successMessage={ successModalDetails.successMessage }
                        closeSuccessModal={ closeSuccessModal }
                    />
            }
             <br/><br/> <br/>
        </>

    )

}
export default UserList;
